import { ProfileForm } from "./ProfileForm";
import type { User } from "@/entities/user";
import { Modal } from "@/shared/ui/Modal";
import { Logo } from "@/shared/ui/svg/Logo";

interface ProfileModalProps {
  user: User | null;
}

export const ProfileModal = ({ user }: ProfileModalProps) => {
  return (
    <Modal>
      <Modal.Trigger asChild>
        <div className="flex gap-2 hover:cursor-pointer">
          <Logo className="w-8 self-center fill-current text-textColor" />
          <div className="flex flex-col">
            <h2 className="max-w-40 truncate font-bold text-textColor">
              #{user?.username}
            </h2>
            <p className="text-left text-sm capitalize text-gray-600 text-textGrayColor">
              {user?.role}
            </p>
          </div>
        </div>
      </Modal.Trigger>
      <Modal.Content>
        <Modal.Title>Профиль</Modal.Title>
        <ProfileForm user={user} />
      </Modal.Content>
    </Modal>
  );
};
